import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useSwipeable} from 'react-swipeable';

import {Container, Offcanvas, ListGroup, Button} from 'react-bootstrap';

import * as IconFi from "react-icons/fi";

import './Contact.scss';

const OffcanvasContact = props => {
    const navigate = useNavigate()

    const data = props.data;

    // ----------------------------------------------------------------------------------------------------- show & hide

    const handlePopstate = () => {

        if (document.querySelectorAll('.offcanvas').length < 2)
            window.removeEventListener('popstate', handlePopstate)

        props.onHide()

    }

    const onShowHandler = () => {

        document.querySelector('#offcanvasContact > div').style.paddingRight = document.querySelector('body').style.paddingRight

        navigate('#offcanvasContact')
        window.addEventListener('popstate',  handlePopstate);

    }

    const onHideHandler = () => {

        navigate(-1)

    }

    const swipe = useSwipeable({
        onSwiping: (data) => {

            if (data.deltaY > 0 && data.deltaY < data.event.target.closest('.offcanvas').offsetHeight)
                data.event.target.closest('.offcanvas').style.transform = `translateY(${data.deltaY}px)`

        },
        onSwiped: (data) => {

            if (data.velocity > .9) {

                data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                onHideHandler()

            } else {

                let h = data.event.target.closest('.offcanvas').offsetHeight
                let translateY = getComputedStyle(data.event.target.closest('.offcanvas')).transform.match(/matrix.*\((.+)\)/)[1].split(', ')[5]

                if (translateY > h / 2) {

                    data.event.target.closest('.offcanvas').style.transform = `translateY(100%)`
                    onHideHandler()

                } else data.event.target.closest('.offcanvas').style.transform = ''
            }

        }
    });

    // -----------------------------------------------------------------------------------------------------------------

    const setHrefHandler = item => {

        item = item.replaceAll(' ', '');

        if (item.startsWith('0')) item = item.substring(1)

        return `tel:+98${item}`

    }

    // -----------------------------------------------------------------------------------------------------------------

    // از کلاس fixed-bottom استفاده شد تا padding-right ایجاد گردد
    return (
        <Offcanvas id="offcanvasContact" {...props} placement="bottom" onHide={onHideHandler} onShow={onShowHandler} className="ltr fixed-bottom">
            <div className="w-100vw">
                <Container fluid="lg" className="px-0 rtl">
                    <Offcanvas.Header className="position-sticky top-0 flex-column flex-md-row">
                        <Button variant="link" className="pt-1 pb-3 align-self-stretch d-flex justify-content-center d-md-none minimize" onClick={onHideHandler} onTouchStart={e => e.target.closest('.offcanvas').classList.add('swiping')} onTouchEnd={e => e.target.closest('.offcanvas').classList.remove('swiping')} {...swipe}/>
                        <Offcanvas.Title>شماره های تماس</Offcanvas.Title>
                        <Button variant="link" className="text-reset border-0 btn-icon d-none d-md-inline-flex" aria-label="Close" onClick={onHideHandler}><IconFi.FiX size={24} className="m-2 sw-1"/></Button>
                    </Offcanvas.Header>
                    <Offcanvas.Body className="pt-0 overflow-visible">
                        <ListGroup variant="flush">
                            {
                                data?.filter((__, index) => index % 2 !== 0).map((item, index) => {
                                    return (
                                        <ListGroup.Item href={setHrefHandler(item)} as="a" className="px-0 bg-transparent border-white-5 d-flex align-items-center" key={index}>
                                            <span className="py-1 d-flex flex-column align-items-start">{data[index * 2]}<span className="ltr ls-1">0{item.substring(1).match(/.{1,2}/g).join(' ')}</span></span>
                                            <IconFi.FiChevronLeft size={24} className="sw-1 ms-auto me-md-2 text-white text-opacity-18"/>
                                        </ListGroup.Item>
                                    )
                                })
                            }
                        </ListGroup>
                    </Offcanvas.Body>
                </Container>
            </div>
        </Offcanvas>
    )
}

export default OffcanvasContact;